const SVG_SCRIPT = /<script\b[^>]*>[\s\S]*?<\/script>/gi;
const SVG_EVENT_HANDLERS = /\s(on\w+)\s*=\s*["'][^"']*["']/gi;
const SVG_FOREIGN_OBJECT = /<foreignObject\b[^>]*>[\s\S]*?<\/foreignObject>/gi;

export function sanitizeSvg(svg: string): string {
    return svg
        .replace(SVG_SCRIPT, '')
        .replace(SVG_EVENT_HANDLERS, '')
        .replace(SVG_FOREIGN_OBJECT, '');
}

const DANGEROUS_TAGS = /<\s*(script|iframe|object|embed|form|link|meta|base|svg\s+on)\b[^>]*>[\s\S]*?<\/\s*\1\s*>/gi;
const DANGEROUS_ATTRS = /\s(on\w+|formaction)\s*=\s*["'][^"']*["']/gi;
const JAVASCRIPT_URL = /javascript\s*:/gi;
const DATA_URL_SCRIPT = /data\s*:\s*text\/html/gi;

export function stripDangerousHtml(input: string): string {
    return input
        .replace(DANGEROUS_TAGS, '')
        .replace(DANGEROUS_ATTRS, '')
        .replace(JAVASCRIPT_URL, '')
        .replace(DATA_URL_SCRIPT, '');
}
